import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetcher = (url) => axios.get(url).then((r) => r.data);
